import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { useEffect, useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router';

const useStyles = makeStyles((theme) => ({
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    // width: '80%',
  },
}));

function useCoordinators() {
  const [coordinators, setCoordinators] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetch('https://api.edicionesmilenio.com/api/coordinators')
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        let c = data?.data?.map((coordinator) => {
          return {
            _id: coordinator?._id,
            name: coordinator?.name,
            lastName: coordinator?.lastName,
            institution: coordinator?.institution?.name,
            phone: coordinator?.phone,
          };
        });
        setCoordinators(c);
      });
  }, []);

  return {
    coordinators,
    setCoordinators,
    isLoading,
  };
}

export function Coordinators(props) {
  const { coordinators, setCoordinators, isLoading } = useCoordinators();
  const navigate = useNavigate();

  const routeChange = (id) => {
    navigate(`/admin/coordinators-update/${id}`);
  };
  const classes = useStyles();

  const columns = [
    {
      name: 'name',
      label: 'Nombre',
      options: {
        filter: false,
      },
    },
    {
      name: 'lastName',
      label: 'Apellido',
      options: {
        filter: false,
      },
    },
    {
      name: 'institution',
      label: 'Institución',
    },
    {
      name: 'phone',
      label: 'Teléfono',
      options: {
        filter: false,
      },
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <Button
              color="primary"
              onClick={() => routeChange(coordinators[dataIndex]?._id)}
            >
              <FaEdit />
            </Button>
          );
        },
      },
    },
  ];

  const handleDelete = async (rowsDeleted) => {
    const confirm = window.confirm(
      '¿Está seguro que desea eliminar los coordinadores seleccionados?'
    );
    if (confirm) {
      rowsDeleted?.data?.forEach(async (row) => {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/coordinators/${
            coordinators[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        let data = await response.json();
      });
    }
  };

  return (
    <div style={{ width: '100%', padding: '20px' }}>
      <p className={classes.formSpan}>
        Estimado administrador, desde esta sección podrás visualizar la lista de
        coordinadores autorizados por la editorial para cada institución
        educativa, recuerda que puedes usar las herramientas de buscar, filtrar,
        entre otras.
      </p>
      {!isLoading ? (
        <MUIDataTable
          title={'Coordinadores'}
          data={coordinators}
          columns={columns}
          options={{
            filterType: 'dropdown',
            onRowsDelete: (rowsDeleted) => {
              handleDelete(rowsDeleted);
            },
          }}
        />
      ) : (
        <CircularProgress color="primary" />
      )}
    </div>
  );
}
